import moment from 'moment';
import {parsePhoneNumber} from 'libphonenumber-js'

export function formatStorageTime(tireStorage) {
    let datesString = 'Lagret fra ' + moment(tireStorage.in_at).format('ll');
    if (tireStorage.out_at) {
        datesString += ' til ' + moment(tireStorage.out_at).format('ll');
    }

    return datesString;
}

export function formatDateTime(value) {
    if (!value) return '';
    return moment(value).format('lll');
}

export function formatPhoneNumber(value) {
    if (!value) return '';
    try {
        return parsePhoneNumber(value).formatNational();
    } catch(e) {
        return 'Ugyldig telefonnummer';
    }
}


export let getCustomerTypeItems = () => {
    return [
        {value: false, text: 'Privat'},
        {value: true, text: 'Bedrift'}
    ]
};

export let getTireTypes = () => {
    return [
        {value: 'S', text: 'Sommerdekk'},
        {value: 'WS', text: 'Piggdekk'},
        {value: 'W', text: 'Piggfrie vinterdekk'},
        {value: 'A', text: 'Helårsdekk'},
    ];
};

export let cleanFilter = (filter) => {
    let newFilter = {};
    Object.keys(filter).forEach(key => {
        let value = filter[key];
        if (!value && value !== false) return;

        if (value === 'true') value = true;
        else if (value === 'false') value = false;
        else if (value === 'null') value = null;
        else {
            let number = parseInt(value, 10);
            if (value === '' + number) value = number;
        }
        newFilter[key] = value;
    });

    return newFilter;
};

export function capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}


export function tableOptionsFromRoute($route) {
    let query = $route.query;
    return {
        page: parseInt(query.page, 10) || 1,
        itemsPerPage: parseInt(query.per_page, 10) || 100,
        sortBy: query.sort ? [query.sort].flat() : ['id'],
        sortDesc: query.desc ? [query.desc === 'true'] : [false]
    }
}

export function updateRouteFromOptions($router, $route, options) {
    $router.replace({
        query: {
            ...$route.query,
            page: options.page || 1,
            per_page: options.itemsPerPage || 100,
            sort: options.sortBy || ['id'],
            desc: options.sortDesc || [false]
        }
    });
}

export const tireStateItems = [
    {value: null, text: '---'},
    {value: 'recommended', text: 'Bør ha nytt'},
    {value: 'confirmed', text: 'Avtalt nytt'},
    {value: 'new', text: 'Satt på nytt'}
];

export const invoiceIntervalItems = [
    {value: 12, text: '1 gang per år'},
    {value: 6, text: '2 ganger per år'},
    {value: null, text: 'Ikke betale'}
]
